import { useI18n } from "@/lib/i18n";
import { HeartHandshake } from "lucide-react";

const AMOUNTS = ["$5", "$10", "$20"];

export const SupportBlock = ({ qrImage, note }) => {
  const { t } = useI18n();
  return (
    <section
      className="mt-20 border border-[#C69A3B] bg-[#F6F0E4] p-8 lg:p-10"
      data-testid="support-block"
    >
      <div className="grid gap-10 lg:grid-cols-[auto_1fr] lg:items-start">
        <div className="mx-auto border border-[#C69A3B]/50 bg-white p-3 lg:mx-0" data-testid="support-qr">
          <img src={qrImage} alt="ATH Móvil" className="h-72 w-72 object-contain" />
        </div>
        <div>
          <p className="label-mono flex items-center gap-2">
            <HeartHandshake size={15} className="text-[#C69A3B]" /> {t("support.label")}
          </p>
          <h2 className="mt-4 font-serif-display text-3xl text-[#8F3329]">{t("support.title")}</h2>
          <div className="gold-rule mt-5 w-24" />
          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-[#5A5752] sm:text-base">
            {t("support.body")}
          </p>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-[#5A5752] sm:text-base">
            {t("support.free")}
          </p>
          {note && <p className="mt-4 text-sm text-[#5A5752]">{note}</p>}
          <div className="mt-6 flex flex-wrap items-center gap-3" data-testid="support-amounts">
            <span className="label-mono">{t("support.amounts")}</span>
            {AMOUNTS.map((a) => (
              <span key={a} className="border border-[#C69A3B] px-4 py-2 font-serif-display text-lg text-[#252525]">
                {a}
              </span>
            ))}
            <span className="text-sm text-[#5A5752]">{t("support.orAny")}</span>
          </div>
          <p className="mt-7 border-t border-[#C69A3B]/40 pt-5 text-sm italic text-[#8F3329]" data-testid="support-thanks">
            {t("support.thanks")}
          </p>
        </div>
      </div>
    </section>
  );
};

export default SupportBlock;
